import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { audienceStylesHash } from 'inside-out/global-styles';

function AudienceIcon({ audience, size }) {
	const viewBox = [0, 0, size, size].join(' ');
	const id = 'tt-' + Math.random() * 99999999;
	return (
		<React.Fragment>
			{audience.title && <ReactTooltip effect="solid" id={id} />}
			<svg
				data-tip={audience.title}
				data-for={id}
				width={size}
				height={size}
				viewBox={viewBox}
				role="tooltip"
				aria-label={audience.title}
				xmlns="http://www.w3.org/2000/svg"
			>
				<g fill={audienceStylesHash[audience.id]}>
					<circle cx="6" cy="6" r="6" />
				</g>
			</svg>
		</React.Fragment>
	);
}

AudienceIcon.propTypes = {
	audience: PropTypes.object,
	size: PropTypes.number,
};

export default AudienceIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/audienceIcon.js